export const WARNING_TITLE = "Are you sure?";
export const WARNING_MESSAGE = "Do you really want to make these changes?";
export const WARNING_INTERNET_EXPLORER =
  "Interet Explorer is not supported. Please use a different browser to access this site.";
export const PROMPT_MESSAGE =
  "You have unsaved changes. Are you sure you want to leave?";

export const ERROR_GENERAL = "Oops! There was an issue. Please try again";
export const ERROR_UNKNOWN = "Unknown Error. Please try again later.";
export const ERROR_TIMEOUT =
  "Unable to reach the server. Please try again later.";
export const ERROR_SESSION_EXPIRED = "Session expired. Logging out...";
export const ERROR_NO_MFA =
  "Multi-factor authentication not set up. Logging out...";
export const ERROR_LOGOUT_INACTIVITY = "Logging out due to inactivity...";
export const ERROR_USER = "Unable to create user";
export const ERROR_MERCHANT = "Unable to create merchant";
export const ERROR_SCANNER = "Unable to create scanner";
export const ERROR_KITCHEN = "Unable to create kitchen user";
export const ERROR_LOGIN_RELOAD =
  "Unable to log in. Please reload the page and try again";
export const ERROR_LOGOUT_NON_ADMIN =
  "Invalid user type. Service only available to admin users. Logging out...";
export const ERROR_LOGIN_EMAIL_UNVERIFIED =
  "Unable to log in. Email is not verified. Please verify your email and try again.";
export const ERROR_TOKEN = "Unable to create token";
export const ERROR_HOLIDAY = "Unable to create holiday";
export const ERROR_TOKEN_DELETE =
  "Unable to delete your session token. Please log out to delete your session token";
export const ERROR_PASSWORD = "Error changing password";
export const ERROR_PASSWORD_MISMATCH = "New passwords must match";

export const SUCCESS_USER = "User successfully created";
export const SUCCESS_MERCHANT = "Merchant successfully created";
export const SUCCESS_SCANNER = "Scanner successfully created";
export const SUCCESS_KITCHEN = "Kitchen user successfully created";
export const SUCCESS_TOKEN = "Token successfully created";
export const SUCCESS_HOLIDAY_CREATE = "Holiday successfully created";
export const SUCCESS_FEE = "Fee successfully created";
export const SUCCESS_FEE_UPDATE = "Fee successfully updated";
export const SUCCESS_PASSWORD = "Password successfully changed";
export const SUCCESS_PASSWORD_RESET =
  "A password reset link has been sent to your email";
export const SUCCESS_TOKEN_DELETE = "Token successfully deleted";
export const SUCCESS_USER_DELETE = "User successfully deleted";
export const SUCCESS_USER_UPDATE = "User successfully updated";
export const SUCCESS_SCANNER_RESIDENCE_UPDATE =
  "Scanner's residence successfully updated";
export const SUCCESS_SEMESTER_MENU_UPDATE =
  "Semester menu successfully updated";
export const SUCCESS_HOLIDAY_DELETE = "Holiday successfully deleted";
export const SUCCESS_DIETARY_OPTION_DELETE =
  "Dietary option successfully deleted";
export const SUCCESS_MEAL_OPTION_DELETE = "Meal option successfully deleted";
export const SUCCESS_MEAL_MENU_DELETE = "Meal menu successfully deleted";
export const SUCCESS_SEMESTER_MENU_DELETE =
  "Semester menu successfully deleted";
export const SUCCESS_SURVEY_DELETE = "Survey successfully deleted";
export const SUCCESS_SURVEY_UPDATE = "Survey successfully updated";
export const SUCCESS_SURVEY_STATUS_UPDATE =
  "Survey status successfully updated";
export const SUCCESS_MEALPERIOD_UPDATE = "Meal successfully updated";
export const SUCCESS_RESIDENCE_UPDATE = "Residence successfully updated";
export const SUCCESS_BALANCE_SETTINGS_UPDATE =
  "Balance Settings successfully updated";
export const SUCCESS_MEAL_SETTINGS_UPDATE =
  "Meal Settings successfully updated";
export const SUCCESS_SYSTEM_SETTINGS_UPDATE =
  "System Settings successfully updated";
export const SUCCESS_HOLIDAY_UPDATE = "Holiday successfully updated";
export const SUCCESS_TERM_HOLIDAY_CREATE = "Term holiday successfully created";
export const SUCCESS_TERM_HOLIDAY_UPDATE = "Term holiday successfully updated";
export const SUCCESS_TERM_HOLIDAY_DELETE = "Term holiday successfully deleted";

export const SUCCESS_PASSWORD_RESET_USER =
  "A password reset email has been sent to ";
export const SUCCESS_EMAIL_VERIFICATION_USER =
  "An email verification email has been sent to ";

export const LOGGING_OUT = "Logging out...";

export const NO_FEE = "No fees set up";
